import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import { Editor, ContentState, EditorState, convertFromRaw } from "draft-js";
import _ from "lodash";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import placeholderBackground from "../../../assets/images/placeholder-background.png";

import AddItemDrawer from "../../../components/Rewards/Cart/AddItemDrawer";

import { newFetch, GET, POST } from "../../../helpers/fetch";
import { config } from "../../../config/index";

const { SERVER_URL } = config;

const ItemDetail = ({
  history,
  match: {
    params: { item_id },
  },
}) => {
  const associate_id = JSON.parse(localStorage.getItem("user")).id;
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [item, setItem] = useState(null);
  const [userPoints, setUserPoints] = useState(0);
  const [quantityLeft, setQuantityLeft] = useState(0);
  const [cart, setCart] = useState(
    localStorage.getItem("cart") ? JSON.parse(localStorage.getItem("cart")) : []
  );
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    if (item) {
      let total = item.redeemed.reduce(
        (total, redeem) => total + redeem.quantity,
        0
      );
      setQuantityLeft(item.quantity - total);
    }
  }, [item]);

  const isJSON = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  const fetchItem = async () => {
    let api_path = `/reward/${item_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setItem(response.results);
      isJSON(response.results.description)
        ? setEditorState(
            EditorState.createWithContent(
              convertFromRaw(JSON.parse(response.results.description))
            )
          )
        : setEditorState(
            EditorState.createWithContent(
              ContentState.createFromText(response.results.description)
            )
          );
    }
  };

  const fetchUserPoints = async () => {
    let api_path = "/associate/aboutme";
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let reward_points = response.data.reward_points;
      setUserPoints(reward_points.points);
    }
  };

  // const handleRedeem = async item_id => {
  //   let quantity = window.prompt('Insert number of item to redeem.', 1)

  //   if (quantity) {
  //     quantity = parseInt(quantity)

  //     if (isNaN(quantity)) {
  //       alert('Input is not a number')
  //     } else {
  //       if (quantity <= 0) {
  //         alert('Quantity should be more than zero.')
  //       } else {
  //         let api_path = `/reward/${item_id}/redeem`
  //         let response = await newFetch(POST, api_path, { quantity })

  //         alert(response.message)

  //         if (response.success) {
  //           fetchUserPoints()
  //           fetchItem()
  //         }
  //       }
  //     }
  //   }
  // }

  useEffect(() => {
    fetchUserPoints();
    fetchItem();
  }, []);

  return (
    <>
      {item && (
        <div className="d-flex flex-column">
          <div>
            {
              <Carousel showStatus={false} showThumbs={false}>
                {item.images.length > 0 ? (
                  item.images.map((image) => (
                    <div style={{ height: "250px" }} className="bg-white">
                      <img
                        style={{ maxWidth: "100%", height: "100%" }}
                        src={`${SERVER_URL}/${image.url}`}
                        alt=""
                      />
                    </div>
                  ))
                ) : (
                  <div>
                    <img src={placeholderBackground} alt="Placeholder" />
                  </div>
                )}
              </Carousel>
            }
          </div>
          <div className="container p-4">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="d-flex flex-column">
                <small className="text-muted">Points to Redeem</small>
                <h5 className="text-brand">
                  {item.type === "redeemable"
                    ? `${item.redeem_points} POINTS`
                    : "FREE"}
                </h5>
              </div>
              <div
                className="badge bg-brand text-white d-flex align-items-center justify-content-center"
                style={{
                  height: "40px",
                  width: "120px",
                  borderRadius: "3.5rem",
                }}
              >
                {quantityLeft} left
              </div>
            </div>
            <div className="d-flex flex-column my-3">
              <button
                className="btn btn-brand btn-block"
                disabled={quantityLeft <= 0}
                onClick={() => setActiveItem(item)}
              >
                Redeem This Item
              </button>
              <div
                className="text-center d-flex align-items-center justify-content-center mt-2"
                style={{ fontSize: "0.8rem" }}
              >
                <div className="text-muted mr-1">Current Points:</div>
                <div className="text-brand">{userPoints}</div>
              </div>
            </div>
            <small className="pt-2 text-muted">Item Name</small>
            <p>{item.name}</p>
            <small className="pt-2 text-muted">Description</small>
            <Editor editorState={editorState} readOnly={true} />
            <small className="pt-2 text-muted">
              Instructions (How to Redeem)
            </small>
            <p>{item.instructions}</p>
            <small className="pt-2 text-muted">Where to Collect</small>
            <p>{item.collection_point}</p>
            <small className="pt-2 text-muted">Remarks</small>
            <p>{item.remarks}</p>
          </div>
        </div>
      )}
      <AddItemDrawer
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        cart={cart}
        setCart={setCart}
      />
    </>
  );
};

export default withRouter(ItemDetail);
